import { FC } from "react";
import styles from "./ClubItem.module.scss";
import { IClub } from "../../types/club";

export const ClubItem: FC<IClub> = ({
  photoUrl,
  website,
  address,
  club,
  description,
  clubsPhotos,
  id,
}) => {
  return (
    <section className={styles.club} id={String(id)}>
      <div className={styles.club_link}>
        <img
          className={styles.img}
          src={
            clubsPhotos.length > 0
              ? clubsPhotos[0].photoUrl
              : "https://placehold.co/400"
          }
          onError={(e) => {
            e.currentTarget.src = "https://placehold.co/400";
          }}
          alt={club}
        />
        <div className={styles.website}>
          <p className={styles.website_title}>WEBSITE</p>
          <a className={styles.website_url} href={website} target="_blank">
            {website}
          </a>
        </div>
        <div className={styles.website}>
          <p className={styles.website_title}>ADRESSE</p>
          <a className={styles.website_url}>{address}</a>
        </div>
      </div>
      <div className={styles.club_info}>
        <h1 className={styles.nameClub}>{club}</h1>
        <p className={styles.text}>{description}</p>
      </div>
    </section>
  );
};
